import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import Icon from '../AppIcon';

const Breadcrumb = () => {
  const location = useLocation();
  const pathnames = location?.pathname?.split('/')?.filter((x) => x);

  const breadcrumbLabels = {
    'asset-details': 'Assets',
    'work-order-details': 'Work Orders',
    'maintenance-schedule': 'Schedule',
    'troubleshooting-guide': 'Troubleshooting',
    'knowledge-base': 'Knowledge Base',
    'analytics-dashboard': 'Analytics'
  };

  if (pathnames?.length === 0) {
    return null;
  }

  return (
    <nav className="breadcrumb" aria-label="Breadcrumb">
      <div className="breadcrumb-item">
        <Link to="/" className="breadcrumb-link">
          <Icon name="Home" size={16} />
        </Link>
      </div>
      {pathnames?.map((pathname, index) => {
        const routeTo = `/${pathnames?.slice(0, index + 1)?.join('/')}`;
        const isLast = index === pathnames?.length - 1;
        const label = breadcrumbLabels?.[pathname] || pathname?.replace(/-/g, ' ');

        return (
          <React.Fragment key={routeTo}>
            <span className="breadcrumb-separator">
              <Icon name="ChevronRight" size={16} />
            </span>
            <div className="breadcrumb-item">
              {isLast ? (
                <span className="breadcrumb-current">{label}</span>
              ) : (
                <Link to={routeTo} className="breadcrumb-link">
                  {label}
                </Link>
              )}
            </div>
          </React.Fragment>
        );
      })}
    </nav>
  );
};

export default Breadcrumb;